import { TableHead } from '@mui/material'
import type { ReactNode } from 'react'
import type { SxProps, Theme } from '@mui/material'
import { COLORS } from '@/lib/constants/colors'
interface ISimpleTableHeadProps {
  children: ReactNode
  sx?: SxProps<Theme>
}

export default function SimpleTableHead({ children, sx }: ISimpleTableHeadProps) {
  return <TableHead sx={{ ...sx, backgroundColor: COLORS.BACKGROUND.SIDEBAR }}>{children}</TableHead>
}
